// extracted by mini-css-extract-plugin
module.exports = {"iconDrip":"calendar-drip_iconDrip__mifI5","utcDrip":"calendar-drip_utcDrip__3s7uy"};